import { API } from '../Api';
import type {
  BrandContentFormat,
  MediaRef,
  PaginationResponse,
} from './brand-deal.api';

// Sàn chiến dịch CÔNG KHAI (spec 2026-10-17): khách chưa đăng nhập cũng xem được danh sách chiến dịch đang tìm creator.
// Không trả gì riêng tư của doanh nghiệp; nhận việc vẫn đi qua các API creator cần đăng nhập (brand-deal.api).
const PUBLIC_BASE = '/v1/payment-service/public/brand-market';

export type PublicCampaignKind = 'Direct' | 'Creative' | 'Proposal';

export interface PublicBrandMarketItem {
  campaignId: string;
  kind: PublicCampaignKind;
  brandName: string;
  ordererKind: string;
  adAccountId: string;
  businessRatingAverage: number | null;
  businessRatingCount: number;
  title: string;
  contentFormat: BrandContentFormat | null;
  summary: string;
  images: MediaRef[];
  slotPriceVnd: number;
  netVnd: number;
  slotsLeft: number;
  slotsTotal: number;
  applyDeadline: string;
  minFollowers: number;
  categories: string[];
  holdDays: number;
  submitDays: number | null;
  maxRevisions: number;
}

export const campaignKindLabel = (k: PublicCampaignKind) =>
  k === 'Direct'
    ? 'Đăng bài'
    : k === 'Creative'
    ? 'Gia công sản phẩm'
    : 'Nhận đề xuất';

export const getPublicBrandMarket = (params: {
  type?: PublicCampaignKind;
  categoryId?: string;
  format?: BrandContentFormat;
  sort?: 'newest' | 'price';
  page?: number;
}) =>
  API.get<PaginationResponse<PublicBrandMarketItem>>(PUBLIC_BASE, {
    params,
  }).then((r) => r.data);

export const getPublicBrandCampaign = (id: string) =>
  API.get<PublicBrandMarketItem>(`${PUBLIC_BASE}/${id}`).then((r) => r.data);
